import { getFreshFileUrl } from './getFreshFileUrl';

/**
 * Mint a fresh signed URL for a file and open it in a new tab for preview.
 * Accepts a StoredFile ({key, originalName}) or a parent doc ({file: {key, ...}}).
 * No-op when the file has no resolvable URL.
 */
export const previewFile = async (file) => {
    const url = await getFreshFileUrl(file);
    if (url) window.open(url, '_blank', 'noopener,noreferrer');
};
